import React from 'react';
export function Footer() {
  return <footer className="bg-black pt-20 pb-10 border-t border-white/10 px-4 sm:px-6 lg:px-8" data-id="element-105" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto" data-id="element-106" data-mp="3ggtzeln15p6t">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-107" data-mp="32nummremu92y">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-108" data-mp="36pfsvtwnvp46">
            <div className="inline-flex flex-col items-center leading-none mb-6" data-id="element-109" data-mp="36qhfmvn1i01q">
              <span className="text-2xl font-normal tracking-[0.4em] text-white pl-[0.4em]" data-id="element-110" data-mp="3uesb1j9yv7im">
                VANTIX
              </span>
              <span className="text-[10px] font-normal tracking-[0.3em] text-white/90 border-t border-amber-400 pt-1.5 mt-1.5 w-full text-center pl-[0.3em]" data-id="element-111" data-mp="387fpncvpdfs">
                CREDIT SOLUTIONS
              </span>
            </div>
            <p className="text-white/50 font-light leading-relaxed text-sm mb-6" data-id="element-112" data-mp="3qf9o6hyl4md5">
              Transformamos tu crédito y desbloqueamos tu acceso a
              financiamiento. Sistema probado, resultados garantizados.
            </p>
          </div>

          {/* Servicios */}
          <div data-id="element-113" data-mp="3lbmsnnzpv0ds">
            <h3 className="text-white font-semibold mb-5 text-sm tracking-wide" data-id="element-114" data-mp="3lbdb8osqm1jp">
              Servicios
            </h3>
            <ul className="space-y-3" data-id="element-115" data-mp="3v89dics1lrft">
              <li data-id="element-116" data-mp="3v9b1fhu5q8ey">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-117" data-mp="3v5n7ihksvjzp">
                  Reparación de Crédito
                </a>
              </li>
              <li data-id="element-118" data-mp="34gtn85h8b3d">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-119" data-mp="335szh7bvjgh">
                  Optimización de Perfil
                </a>
              </li>
              <li data-id="element-120" data-mp="cw3617tjwg7p">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-121" data-mp="qt8gdk0as18r">
                  Fondeo Empresarial
                </a>
              </li>
              <li data-id="element-122" data-mp="twfs04aigfx6">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-123" data-mp="tt07un1zcgow">
                  Asesoría Personalizada
                </a>
              </li>
            </ul>
          </div>

          {/* Compañía */}
          <div data-id="element-124" data-mp="18m3sj3avbaju">
            <h3 className="text-white font-semibold mb-5 text-sm tracking-wide" data-id="element-125" data-mp="1clmd1xys1jm5">
              Compañía
            </h3>
            <ul className="space-y-3" data-id="element-126" data-mp="1hk5xftxq2nce">
              <li data-id="element-127" data-mp="1hj4buvj2yigf">
                <a href="#proceso" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-128" data-mp="1hms4ztkm52um">
                  Nuestro Proceso
                </a>
              </li>
              <li data-id="element-129" data-mp="3obx0n9bhoqta">
                <a href="#resultados" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-130" data-mp="3ocghsntbfb69">
                  Resultados
                </a>
              </li>
              <li data-id="element-131" data-mp="2agyaywqwuhk0">
                <a href="#faq" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-132" data-mp="25onb1tw66vrg">
                  Preguntas Frecuentes
                </a>
              </li>
              <li data-id="element-133" data-mp="1wpa3x7viqj9w">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-134" data-mp="1wlmas9tzjyvp">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div data-id="element-135" data-mp="2kbgmup6hdjew">
            <h3 className="text-white font-semibold mb-5 text-sm tracking-wide" data-id="element-136" data-mp="2kf4flm43q1sk">
              Contacto
            </h3>
            <ul className="space-y-3" data-id="element-137" data-mp="18xutertl8vnk">
              <li data-id="element-138" data-mp="18yxprf9ojqav">
                <a href="tel:+14073678672" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-139" data-mp="18w1nxfupohh5">
                  +1 (407) 367-8672
                </a>
              </li>
              <li data-id="element-140" data-mp="2wmpo2fo6voj4">
                <a href="mailto:eduardo@vantixcreditsolutions.com" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-141" data-mp="2wn994594yt1d">
                  eduardo@vantixcreditsolutions.com
                </a>
              </li>
              <li className="text-white/50 text-sm font-light" data-id="element-142" data-mp="3bl1nuv6uzdei">
                Miami · Houston · Los Angeles
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40" data-id="element-143" data-mp="31m2f7cm3fhri">
          <p data-id="element-144" data-mp="36j2l9niy0kim">
            © {new Date().getFullYear()} Vantix Credit Solutions. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6" data-id="element-145" data-mp="1v5gvq1968gwk">
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-146" data-mp="1v6iaafpeblj1">
              Privacidad
            </a>
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-147" data-mp="1nkedqn6hrnwv">
              Términos
            </a>
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-148" data-mp="1ioz281vyi43m">
              Aviso Legal
            </a>
          </div>
        </div>
      </div>
    </footer>;
}